import axios from 'axios'
import { getEmailFromUserId } from './utils/event-helpers'

export function requireEnv(name: string){
    const value = process.env[name]
    if (!value) throw new Error(`Environment variable ${name} is not set`)
    return value
}

export async function postGrade(grade: number){
    const litjsEndpint = requireEnv('REACT_APP_LITJS_ENDPOINT')
    try {
        const body = {
            grade: grade
        }
        await axios.post(litjsEndpint + '/grade', body, { 
            withCredentials: true,
            headers: { 
                'Authorization': 'Bearer ' + getLtik(),
                'Content-Type': 'application/json'
            } 
        })
    } catch (error) {
        console.error('Error posting grade:', error)
    }
}

const getLtik = () => {
    const searchParams = new URLSearchParams(window.location.search)
    const ltik = searchParams.get('ltik')
    if (!ltik) throw new Error('Missing lti key.')
    return ltik
}

export function addUrlParams(url: string, params: Record<string, string>){
    const urlParams = new URLSearchParams(params)
    return url + '?' + urlParams.toString()
}

export interface FieldScore {
    field: string;
    score: number;
  }

export interface MentorRecommendations {
    subfieldScores: FieldScore[];
    pageFieldScores: FieldScore[];
}

export async function mentorSessionRecommendations(userId: string, sessionId: string, numResults: number, timestampStart: string, timestampEnd?: string): Promise<MentorRecommendations> {
    const endpoint = requireEnv('REACT_APP_MENTOR_LRS_RECOMMENDATIONS_ENDPOINT')

    const url = addUrlParams(endpoint, {
        name: userId,
        sessionId: sessionId,
        mbox: `mailto:${getEmailFromUserId(userId)}`,
        timestampStart: timestampStart,
        ...(timestampEnd && { timestampEnd: timestampEnd }),
        numResults: numResults.toString(),
    })
    try {
        const response = await axios.get(url)
        return response.data as MentorRecommendations
    }
    catch (error) {
        console.error('Error getting mentor session recommendations:', error)
    }
}
